import { MenuItemType, SingleItemDropdownInterface } from '../types/menu-interface'
import { isFlatMenuItem } from './is-flat-menu-item'

export const checkNestedRendered = (items: MenuItemType[]): boolean => {
  return items.some(item =>
    isFlatMenuItem(item) ? item.shouldRender : checkNestedRendered(item.dropdownItems),
  )
}
